module.exports = __webpack_public_path__ + "images/emoji/green_apple.c29768d26392a2471a4b.png";